import React, { lazy } from "react";
import "./Home.css";
import Navbar from "../../../Gerneralcomponents/Navbar/Navbar";
import Carouselcomp from "../../../Gerneralcomponents/Bannerprincipal/Carouselcomp";
import { useGetplan } from "../../../Hooks/useGetplan";
import CotizadortestIni from "../../../Gerneralcomponents/Cotizardor/CotizardortestInicial";

const Footer = lazy(() => import("../../../Gerneralcomponents/Footer/footer"));
const Card = lazy(() => import("../../../Gerneralcomponents/Card/Cards"));
const Subcarouselcomp = lazy(() => import("../../../Gerneralcomponents/Bannersecundario/Subcarouselcomp"));
const Addhelp = lazy(() => import("../../../Gerneralcomponents/Helpcomp/Addhelp"));
const CampaignCards = lazy(() => import("../../../Gerneralcomponents/Card/CampaignCards"));

const Home = () => {
  window.sessionStorage.clear();
  window.localStorage.clear();

  return (
    <>
     
        <title>Emcali Internet - Servicios de Fibra Óptica</title>
        <meta name="description" content="Descubre los servicios de internet por fibra óptica de Emcali, con las mejores velocidades y precios en el mercado." />
        <meta property="og:title" content="Emcali Internet - Servicios de Fibra Óptica" />
        <meta property="og:description" content="Descubre los servicios de internet por fibra óptica de Emcali, con las mejores velocidades y precios en el mercado." />
        <meta property="og:url" content="https://portalservicios.emcali.net.co"/>
        <meta property="og:type" content="website" />
        <meta name="keywords" content="Emcali, Emcali Internet, Internet, Fibra optica, Cali, Jamundi, Yumbo" />
   
      <div className="overflow-y-auto h-screen overflow-x-hidden"
      style={{
        height: 'calc(100vh - 4rem)', // Resta el alto del navbar
        marginTop: '4rem' // Opcional, si quieres separar visualmente
      }}>
        <header>
          <h1>Servicios de Internet por Fibra Óptica de Emcali</h1>
        </header>
        <main >
          <Navbar />
          <a className="fixed bg-colorprimary rounded-xl text-white p-6 h-8 w-24 hover:bg-colorsecondary z-50 bottom-0 right-0 m-6 flex justify-center items-center animate-bounce" href="/Ayuda">¿Ayuda?</a>
          <Carouselcomp />
          <CampaignCards />
          <CotizadortestIni
            funcion={useGetplan}
            onclickfun={"fun()"}
            // ruta={"/prebuy"}
            ruta={"/valout"}
            nombreButton={"Adquirir plan"}
            displaycall={""}
          />
          <Subcarouselcomp />
          <Card />
          <Addhelp />
        </main>
        <footer>
          <Footer />
        </footer>
      </div>
    </>
  );
};

export default Home;